import apiClient from './apiClient';


export const getUserRecharge = (params) => {
    return apiClient.get('/deposit', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
}
export const getHandleDeposit = (id, status) => {
  return apiClient.post(`/deposit/${id}`, { status });
};



// 提现
export const getUserWithdraw = (params) => {
  return apiClient.get('/withdraw', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
};

export const handleWithdraw = (id, status, remark) => {
  return apiClient.post(`/withdraw/${id}`, { status, remark });
};

export const getUserBalanceRecord = (params) => {
  return apiClient.get('/balance_record', { params })
    .then(response => ({
      data: {
        items: response.data.rows,
        total: response.data.count
      }
    }));
};

